<template>
  <div class="checkin-page page safe-page">
    <!-- 顶部返回按钮 -->
    <div class="header flex justify-between items-center mb-10px sky-header">
      <div class="back-btn" @click="handleBack">
        <img src="@/assets/images/mine/left.webp" class="w-30px h-30px" />
      </div>
      <div class="title color-#fff text-16px font-900">
        {{ t('checkIn.freeGems') }}
      </div>
      <div class="w-40px h-28px"></div>
    </div>
    <!-- 7 日签到卡片 -->
    <div
      class="checkin-container relative"
      :class="[
        ![4, 5, 3].includes(userStore.userInfo.role) ? 'vip' : '',
        [4, 5].includes(userStore.userInfo.role) ? ' h-257px' : ' h-387px'
      ]"
    >
      <div
        class="w-100% h-100% absolute box-bg top-0px left-0px bg-#01031B/50 z-1"
        v-if="[4, 5, 3].includes(userStore.userInfo.role)"
      >
        <!-- <img src="@/assets/images/checkInCenter/vip_bg.svg" class="w-100% h-100%" /> -->
      </div>
      <div class="checkin-card absolute top-20px w-94% h-257px z-2">
        <div class="card-header relative">
          <img
            src="@/assets/images/checkInCenter/line.webp"
            class="absolute bottom--5px right-100px w-66px"
          />
          <span class="title">{{ t('checkIn.sevenDayCheckIn') }}</span>
          <img src="@/assets/images/checkInCenter/star.webp" class="icon" />
        </div>

        <div class="check_in mt-15px" v-if="![4, 5].includes(userStore.userInfo.role)">
          <div class="flex items-center justify-around">
            <div class="flex flex-col items-center justify-center">
              <div class="flex items-center justify-center">
                <div class="text-24px font-900">
                  {{ days.find(day => day.isGet === 0)?.amount }}
                </div>
                <div class="flex w-20px h-20px items-center justify-center">
                  <img src="@/assets/images/home/crystal.webp" class="w-full h-full" />
                </div>
              </div>
              <div class="text-12px">Base</div>
            </div>
            <div class="flex items-center justify-center">
              <img src="@/assets/images/checkInCenter/ss.webp" class="w-32px h-24px" />
            </div>
            <div class="flex flex-col items-center justify-center">
              <div class="flex items-center justify-center">
                <div class="text-24px font-900">
                  <div v-if="[3].includes(userStore.userInfo.role)">
                    {{
                      days.find(day => day.isGet === 0)?.extraRewardsForCheckInUltra +
                      days.find(day => day.isGet === 0)?.vipAmount
                    }}
                  </div>
                  <div v-else>
                    {{
                      days.find(day => day.isGet === 0)?.extraRewardsForCheckInUltra +
                      days.find(day => day.isGet === 0)?.amount
                    }}
                  </div>
                </div>
                <div class="flex w-20px h-20px items-center justify-center">
                  <img src="@/assets/images/home/crystal.webp" class="w-full h-full" />
                </div>
              </div>
              <div class="text-12px">Upgrade</div>
            </div>
          </div>
        </div>

        <div class="overflow-x-auto pt-10px">
          <!-- 非vip -->
          <div
            class="days-container mb-0px! pb-0px!"
            v-if="![4, 5].includes(userStore.userInfo.role)"
          >
            <div
              class="relative text-center"
              v-for="(day, idx) in days"
              :key="idx"
              :style="{ animationDelay: `${idx * 0.1}s` }"
            >
              <div
                :class="{ 'color-#7284F7': day.isGet || isToday === idx }"
                class="text-10px color-#fff day-label-text mb-5px"
              >
                {{ t('checkIn.day', { num: idx + 1 }) }}
              </div>
              <div
                class="day-item"
                :class="{
                  checked: day.isGet,
                  current: isToday === idx
                }"
              >
                <div class="absolute top-12px flex items-center justify-center" v-if="day.isGet">
                  <img src="@/assets/images/checkInCenter/check.svg" class="w-22px h-22px" />
                </div>
                <div class="gem-icon">
                  <img src="@/assets/images/home/crystal.webp" class="w-20px h-20px" />
                </div>
                <div class="gem-amount">
                  +{{ [3].includes(userStore.userInfo.role) ? day.vipAmount : day.amount }}
                </div>
              </div>
              <div class="relative mt-5px" :style="{ animationDelay: `${idx * 0.1 + 0.5}s` }"></div>
            </div>
          </div>
          <!-- vip -->
          <div
            class="days-container pt-0px! mb-0px!"
            v-if="[4, 5].includes(userStore.userInfo.role)"
          >
            <div
              class="relative text-center"
              v-for="(day, idx) in days"
              :key="idx"
              :style="{ animationDelay: `${idx * 0.1}s` }"
            >
              <div
                class="day-item"
                :class="{
                  checked: day.isGet,
                  current: [4, 5].includes(userStore.userInfo.role) && isToday === idx
                }"
              >
                <div
                  class="absolute top--5px right-3px"
                  v-if="![4, 5].includes(userStore.userInfo.role)"
                >
                  <img src="@/assets/images/checkInCenter/lock.webp" class="w-8px h-10px" />
                </div>
                <div class="absolute top-12px flex items-center justify-center" v-if="day.isGet">
                  <img src="@/assets/images/checkInCenter/check.svg" class="w-22px h-22px" />
                </div>
                <div class="gem-icon">
                  <img src="@/assets/images/home/crystal.webp" class="w-20px h-20px" />
                </div>
                <div class="gem-amount" v-if="[4].includes(userStore.userInfo.role)">
                  +{{ getTaskAllAmount(day, userStore.userInfo.role) }}

                </div>
                <div class="gem-amount" v-else>
                  +{{ getTaskAllAmount(day, userStore.userInfo.role) }}

                </div>
              </div>
              <div
                class="relative mt-10px"
                :style="{ animationDelay: `${idx * 0.1 + 0.5}s` }"
              ></div>
            </div>
          </div>
          <div class="days-container pt-0px! mb-0px!" v-else>
            <div
              class="relative text-center"
              v-for="(day, idx) in days"
              :key="idx"
              :style="{ animationDelay: `${idx * 0.1}s` }"
            >
              <div
                class="day-item"
                :class="{
                  checked: day.isGet,
                  current: [4, 5].includes(userStore.userInfo.role) && isToday === idx
                }"
              >
                <div
                  class="absolute top--5px right-3px"
                  v-if="![4, 5].includes(userStore.userInfo.role)"
                >
                  <img src="@/assets/images/checkInCenter/lock.webp" class="w-8px h-10px" />
                </div>
                <!-- <div class="absolute top-12px flex items-center justify-center" v-if="day.isGet">
                  <img src="@/assets/images/checkInCenter/check.svg" class="w-22px h-22px" />
                </div> -->
                <div class="gem-icon">
                  <img src="@/assets/images/home/crystal.webp" class="w-20px h-20px" />
                </div>
                <div class="gem-amount" v-if="[4].includes(userStore.userInfo.role)">
                  +{{ getTaskAllAmount(day, userStore.userInfo.role) }}
                </div>
                <div class="gem-amount" v-else>
                  +{{ getTaskAllAmount(day, userStore.userInfo.role) }}
                </div>
              </div>
              <div
                class="relative mt-10px"
                :style="{ animationDelay: `${idx * 0.1 + 0.5}s` }"
              ></div>
            </div>
          </div>
        </div>

        <div v-if="!hasAllSignedToday">
          <div v-if="isSignedSevenDays" class="btn-checkin">
            <div class="text-12px font-500 text-center mt-10px checkin-btn-r" @click="goToVip">
              {{ t('checkIn.getVip') }}
            </div>
          </div>
          <div v-else>
            <div class="btn-checkin">
              <div v-if="[4, 5].includes(userStore.userInfo.role)" class="btn-checkin block!">
                <div
                  class="bonus"
                  v-if="[5].includes(userStore.userInfo.role)"
                  style="
                    background: linear-gradient(0deg, #e9d6ff 0%, #a66cfe 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                  "
                >
                  You are already a VIP Ultra !
                </div>
                <div
                  class="bonus"
                  v-if="[4].includes(userStore.userInfo.role)"
                  style="
                    background: linear-gradient(0deg, #ffdfb3 0%, #eab04e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                  "
                >
                  You are already a VIP Plus !
                </div>
                <!-- <div class="mt-20px text-12px font-500 py-10px text-center mt-10px checkin-btn-r relative">
                  Claim
                </div> -->
                <div>
                  <div
                    class="text-12px font-500 text-center mt-20px checkin-btn-r-ultra"
                    @click="handleCheckIn(true, 'ultra')"
                    v-if="isGetToday === 0"
                  >
                    Claim
                  </div>
                  <div class="text-12px font-500 text-center mt-20px checkin-btn-r-ultra-ed" v-else>
                    Claimed
                  </div>
                </div>
              </div>
              <div class="btn-checkin" v-else>
                <div class="flex-1">
                  <div
                    class="text-12px font-500 text-center py-10px mt-10px checkin-btn-r"
                    @click="handleCheckIn(false)"
                    v-if="isGetToday === 0"
                  >
                    Claim
                  </div>
                  <div
                    class="text-12px relative font-500 text-center py-8px mt-10px opacity-50 checkin-btn-r-ed"
                    v-else
                  >
                    Claimed
                  </div>
                </div>
                <div
                  class="text-12px font-500 text-center mt-10px checkin-btn-l-upgrade"
                  @click="handleCheckIn(true)"
                >
                  Upgrade
                  <span class="absolute top--10px right-0 Ultra"> Ultra </span>
                </div>
              </div>
            </div>
            <!-- <div class="color-#fff text-12px font-500 text-center mt-10px checkin-text" v-else>
              {{ t('checkIn.signedInTip') }}
            </div> -->
          </div>
        </div>
        <div class="color-#fff text-12px font-500 text-center" v-else>
          {{ t('checkIn.signedInTip') }}
        </div>
      </div>
    </div>

    <!-- 任务列表 -->
    <div class="tasks-section">
      <div class="tasks-header">
        <!-- <img src="@/assets/images/checkInCenter/gift_icon.webp" class="w-20px h-20px" /> -->
        <span class="tasks-title color-#fff mb-15px">{{ t('checkIn.tasks') }}</span>
      </div>
      <!-- <div class="tasks-subtitle color-#01031B text-9px">Complete tasks and gain growth rewards</div> -->

      <div class="task-list">
        <div
          class="task-item"
          v-for="(task, idx) in taskList"
          :key="task.id"
          :style="{ animationDelay: `${idx * 0.1 + 0.1}s` }"
        >
          <!-- <div class="task-icon">
            <img :src="getTaskIcon(task.id)" class="w-24px h-24px" />
          </div> -->
          <div class="task-content">
            <div class="task-name">{{ task.title }}</div>
            <div class="task-desc ml-5px" v-if="![12, 13, 14].includes(task.id)">
              ({{ task.process }}/{{ task.condition }})
            </div>
          </div>
          <div class="">
            <div class="w-full" v-if="![12, 13, 14].includes(task.id)">
              <div
                v-if="task.process !== task.condition"
                class="task-actions flex items-center justify-between w-full"
              >
                <div class="task-btn" @click="handleTaskAction(task)">
                  {{ t('checkIn.go') }}
                </div>

                <div class="task-reward">
                  <span>+{{ task.amount }}</span>
                  <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px" />
                </div>
              </div>
              <div v-else class="task-btn-receive" :class="task.gotten ? 'active' : ''">
                <div
                  v-if="!task.gotten"
                  @click="handleGetTaskReward(task)"
                  class="flex items-center justify-center"
                >
                  <div class="w-14px h-14px flex items-center justify-center mr-3px mt-1px">
                    <img src="@/assets/images/home/crystal.webp" class="w-full h-full" />
                  </div>
                  <div class="task-reward">
                    <span>+{{ task.amount }}</span>
                  </div>
                </div>
                <div v-else>Claimed</div>
              </div>
            </div>

            <div class="w-full" v-else>
              <div
                v-if="!getTaskAmount(task) && !task.gotten"
                class="task-actions flex items-center justify-between w-full"
              >
                <div class="task-btn" @click="handleTaskAction(task)">
                  {{ t('checkIn.go') }}
                </div>

                <div class="task-reward">
                  <span>+{{ task.amount }}</span>
                  <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px" />
                </div>
              </div>
              <div v-else class="task-btn-receive" :class="task.gotten ? 'active' : ''">
                <div
                  @click="handleGetTaskReward(task)"
                  v-if="!task.gotten"
                  class="flex items-center justify-center"
                >
                  <div class="w-14px h-14px flex items-center justify-center mr-3px mt-1px">
                    <img src="@/assets/images/home/crystal.webp" class="w-full h-full" />
                  </div>
                  <div class="task-reward">
                    <span>+{{ task.amount }}</span>
                  </div>
                </div>
                <div v-else>Claimed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppNewUser :amount="amount" :isNewUser="false" v-model:show="showAppNewUser" />
    <FirstChargePopUp v-model:showPopup="showPopupFirstCharge" url="/" />
    <AppOccupySpace height="100px" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { AppOccupySpace } from '@/components/layout'
import AppNewUser from '@/components/feedback/AppNewUser.vue'
import { showLoadingToast, showErrorToast, closeToast } from '@/utils/toast'
import { CheckCenterAPI } from '@/services/checkCenter'
import { useCheckInCenterStore } from '@/stores/checkInCenter'
import { useUserStore } from '@/stores/user'
import { theme } from '@/styles/theme'
import FirstChargePopUp from '@/views/home/com/FirstChargePopUp.vue'
import { useI18n } from 'vue-i18n'
import { getStaySeconds } from '@/utils/stayTracker'
const { t } = useI18n()
const days = computed(() => useCheckInCenterStore().days)
const isGetToday = computed(() => useCheckInCenterStore().isGetToday)
const userStore = useUserStore()
const showAppNewUser = ref(false)
const amount = ref(0)
const STORAGE_SIGNED_DATES = 'checkin_signed_dates'
const STORAGE_LAST_RESET = 'checkin_last_reset_week'
const STORAGE_LAST_CHECKIN_DATE = 'checkin_last_date'
const showPopupFirstCharge = ref(false)

// 状态
const signedDates = ref<Set<string>>(new Set())
const lastCheckinTimestamp = ref<number>(0) // 响应式的签到时间戳
/**
 * 检查今天是否可以签到
 * 如果今天已经签到过（存储的日期是今天且在8点之后），则不显示按钮
 */
const canCheckInToday = () => {
  const index = days.value.findLastIndex(day => day.isGet === 1)
  return index === -1 ? 0 : index
}
const isToday = computed(() => {
  const index = days.value.findLastIndex(day => day.isGet === 1)
  return index === -1 ? 0 : index + 1
})
/**
 * 跳转到VIP页面
 */
const goToVip = () => {
  router.push({ name: 'Vip' })
}

const hasAllSignedToday = computed(() => {
  return days.value.every(day => day.isGet === 1)
})
const signedCount = computed(() => {
  // 统计已签到的天数（isGet 为 true）
  return days.value.filter(day => day.isGet).length
})
const progressPercent = computed(() => {
  if (days.value.length === 0) return 0
  // 根据已签到的天数计算百分比
  const checkedDays = days.value.filter(day => day.isGet).length
  return Math.round((checkedDays / days.value.length) * 100)
})

// 任务（简单本地状态占位）
type TaskStatus = 'go' | 'receive' | 'done'
interface TaskItem {
  id: string
  title: string
  goal: number
  progress: number
  amount: number
  gotten: boolean
}
const router = useRouter()
const taskList = computed(() => useCheckInCenterStore().taskList)

/**
 * 获取当前时间
 */

const isStay = () => {
  if (localStorage.getItem('isStay') === '1') {
    return true
  }
  return false
}

const getCurrentTime = () => {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}${m}${day}`
}
/**
 * 加载状态
 */
function loadState() {
  // 每周一重置（以 ISO week 计算的简单近似：使用 年-周）
  const now = new Date()
  const firstDayOfYear = new Date(now.getFullYear(), 0, 1)
  const pastDaysOfYear = (Number(now) - Number(firstDayOfYear)) / 86400000
  const week = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
  const weekKey = `${now.getFullYear()}-W${week}`

  const lastReset = localStorage.getItem(STORAGE_LAST_RESET)
  if (lastReset !== weekKey) {
    // 新的一周，重置
    localStorage.setItem(STORAGE_LAST_RESET, weekKey)
    localStorage.removeItem(STORAGE_SIGNED_DATES)
  }

  const raw = localStorage.getItem(STORAGE_SIGNED_DATES)
  if (raw) {
    try {
      const list: string[] = JSON.parse(raw)
      signedDates.value = new Set(list)
    } catch (e) {
      signedDates.value = new Set()
    }
  }
}

/**
 * 任务操作
 */
function handleTaskAction(task: TaskItem) {
  // 去对应页面（占位导航）
  const map: Record<string, string> = {
    7: 'Store',
    8: 'Store',
    9: 'Home',
    3: 'Home'
  }
  const name = map[task.type]
  if (name) router.push({ name })
}

const getTaskAllAmount = (data: any, id: any) => {
  if ([4].includes(id)) {
    if ([3,4,5].includes(id)) {
      return data.vipAmount + data.extraRewardsForCheckInPlus
    }
    return data.amount + data.extraRewardsForCheckInPlus
  }else{
    if ([3,4,5].includes(id)) {
      return data.vipAmount + data.extraRewardsForCheckInUltra
    }
    return data.amount + data.extraRewardsForCheckInUltra
  }
}

const handleGetTaskReward = async (task: TaskItem) => {
  if (task.gotten) {
    return
  }
  showLoadingToast('Getting reward...')
  await CheckCenterAPI.getTaskReward({
    curDate: Number(getCurrentTime()),
    taskId: task.id
  })

  // 更新用户信息
  await userStore.getUserInfo()
  // 更新任务列表
  useCheckInCenterStore().getCheckInCenterList()
  // 关闭加载提示
  closeToast()

  // 显示新用户弹窗
  amount.value = task.amount
  showAppNewUser.value = true
}

/**
 * 返回
 */
function handleBack() {
  router.back()
}

/**
 * 是否签到满7天
 */
const isSignedSevenDays = computed<boolean>(() => {
  const allGet = days.value.every(day => day.isGet === 1)
  if (allGet) {
    if ([3, 4, 5].includes(userStore.userInfo.role)) {
      return false
    }
    return true
  }
  return false
})

/**
 * 获取任务图标
 */
function getTaskIcon(taskId: string): string {
  const iconMap: Record<string, string> = {
    1: new URL('@/assets/images/checkInCenter/heart.svg', import.meta.url).href,
    2: new URL('@/assets/images/checkInCenter/chat.svg', import.meta.url).href,
    3: new URL('@/assets/images/checkInCenter/message.svg', import.meta.url).href,
    4: new URL('@/assets/images/checkInCenter/level.svg', import.meta.url).href
  }
  return (
    iconMap[taskId] || new URL('@/assets/images/task/default.svg', import.meta.url).href
  ) /* @vite-ignore */
}
/**
 * 用户签到
 */
const handleCheckIn = async (isVip?: boolean, vip?: string) => {
  if (isVip) {
    if (![5, 4].includes(userStore.userInfo.role)) {
      router.push({ name: 'Vip', query: { type: 'u', tab: 'chat' } })
      return
    }
  }
  showLoadingToast('Check-in...')

  try {
    await CheckCenterAPI.getUserSignIn({
      userDate: Number(getCurrentTime())
    })

    const isSginIn = days.value.find(item => item.isGet === 0)

    localStorage.setItem('isSginIn', isSginIn.day)

    // 记录签到时间
    const now = new Date().getTime()
    localStorage.setItem(STORAGE_LAST_CHECKIN_DATE, String(now))

    //获取当天时间
    const timestamp = new Date(new Date().toLocaleDateString()).getTime()

    localStorage.setItem('today', String(timestamp))

    await useCheckInCenterStore().getSignInList()

    await userStore.getUserInfo()

    lastCheckinTimestamp.value = now // 更新响应式变量，触发按钮隐藏
    closeToast()
    amount.value = [3].includes(userStore.userInfo.role)
      ? isSginIn.vipAmount
      : [4].includes(userStore.userInfo.role)
        ? isSginIn.extraRewardsForCheckInPlus + isSginIn.vipAmount
        : [5].includes(userStore.userInfo.role)
          ? isSginIn.extraRewardsForCheckInUltra + isSginIn.vipAmount
          : isSginIn.amount
    showAppNewUser.value = true
  } catch (error) {
    showErrorToast('Check-in failed. Please try again')
  }
}

const getTaskAmount = (task: any) => {
  if (getStaySeconds() >= 180 && task.id === 12) {
    return true
  } else if (getStaySeconds() >= 300 && task.id === 13) {
    return true
  } else if (getStaySeconds() >= 1800 && task.id === 14) {
    return true
  }
  return false
}

/**
 * 任务列表
 */
onMounted(async () => {
  await useCheckInCenterStore().getCheckInCenterList()
  await useCheckInCenterStore().getSignInList()
  // 初始化时从 localStorage 读取上次签到时间
  const savedTimestamp = localStorage.getItem(STORAGE_LAST_CHECKIN_DATE)
  if (savedTimestamp) {
    lastCheckinTimestamp.value = Number(savedTimestamp)
  }
  loadState()
})

window.addEventListener('paymentResult', function () {
  showPopupFirstCharge.value = false
})
</script>

<style scoped lang="scss">
.checkin-page {
  min-height: 100vh;
  background: #01031b;
  padding: 10px;
}

.sky-header {
  position: sticky;
  top: 0px;
  z-index: 99;
  background-color: #01031b;
}

// 顶部返回按钮
.header {
  .back-btn {
    width: 40px;
    height: 40px;
    // background: rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
}

// Gem Rewards 标题区
.rewards-header {
  overflow: hidden;
  width: 100%;
  background-image: url('@/assets/images/checkInCenter/background.webp');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px 20px;
  padding-top: 10px;

  .gift-icon {
    position: absolute;
    bottom: -40px;
    left: 10px;
  }

  .title-wrapper {
    text-align: center;
    margin-top: 90px;
  }

  .balloons {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

// 签到卡片容器
.checkin-container {
  padding: 0 10px;
  border-radius: 20px;

  &.vip {
    background: linear-gradient(180deg, #272f40 0%, #2c2e3f 100%);
  }
}

// 签到卡片
.checkin-card {
  // background: linear-gradient(180deg, #EEF1FF 0%, #FFFFFF 100%);
  border-radius: 20px;
  // padding: 10px;
  // box-shadow: 0 4px 20px rgba(123, 136, 255, 0.15);

  .card-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 8px;

    .icon {
      width: 20px;
      height: 20px;
    }

    .title {
      font-size: 18px;
      font-weight: 800;
      color: #6b7fff;
    }
  }

  .subtitle {
    text-align: center;
    font-size: 12px;
    color: #9ca3af;
    margin-bottom: 16px;
    background-image: url('@/assets/images/checkInCenter/title_bg.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    font-weight: 500;
    font-size: 10px;
    padding: 5px 0;
    color: #ffffff;
  }

  .days-container {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
    // overflow-x: auto;
    padding: 4px 0;

    .day-item {
      flex-shrink: 0;
      width: 38px;
      height: 65px;
      // border: 1.5px solid #E5E7EB;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      transition: all 0.3s ease;
      // background: linear-gradient(180deg, #C9D8FF 0%, #FFFFFF 100%);
      background: rgba(255, 255, 255, 0.1);
      animation: dayItemSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;

      @keyframes dayItemSlideIn {
        0% {
          transform: translateY(20px) scale(0.8);
          opacity: 0;
        }

        100% {
          transform: translateY(0) scale(1);
          opacity: 1;
        }
      }

      opacity: 0.5 !important;

      .absolute-center {
        border-radius: 10px;
        border-color: transparent !important;
      }

      .gem-icon {
      }

      .gem-amount {
        font-size: 14px;
        font-weight: 700;
        // color: #6B7280;
        color: #c4c7d1;
      }

      .day-label {
        font-size: 10px;
        color: #9ca3af;
      }

      &.checked {
        // background: linear-gradient(180deg, #7B88FF 0%, #A78BFA 100%);
        border-color: #7b88ff;
        border: 1px solid #3859d8;

        .gem-amount {
          color: #fff;
        }

        .day-label {
          color: rgba(255, 255, 255, 0.8);
        }
      }

      &.current {
        opacity: 1 !important;
        border: 1px solid #7b88ff;
        // background: none;
        // background: linear-gradient(180deg, rgba(90, 104, 255, 0.2) 0%, rgba(149, 165, 255, 0.2) 100%);

        .gem-amount {
          color: #ffffff !important;
        }

        // box-shadow: 0 0 0 4px rgba(123, 136, 255, 0.2);
      }
    }
  }

  .progress-section {
    margin-bottom: 16px;
    position: relative;
    width: 130%;
  }

  .progress-bar {
    width: 100%;
    height: 1px;
    // background: #E5E7EB;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 8px;
    position: relative;

    // 进度条上的小圆点
    // &::before {
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 12px;
    //   height: 12px;
    //   background: #7B88FF;
    //   border-radius: 50%;
    //   border: 2px solid #FFFFFF;
    //   z-index: 2;
    // }
  }

  .progress-fill-item {
    background: rgba(255, 255, 255, 0.3);
    width: 38px;
    height: 1px;
  }

  .progress-labels {
    display: flex;
    justify-content: space-between;

    // gap: 8px;

    .progress-label {
      flex-shrink: 0;
      text-align: center;
      font-size: 10px;
      color: #9ca3af;
      position: relative;
      animation: labelFadeIn 0.4s ease-out both;

      @keyframes labelFadeIn {
        0% {
          transform: translateY(10px);
          opacity: 0;
        }

        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

  .btn-checkin {
    width: 100%;
    // height: 45px;
    display: flex;
    gap: 10px;

    .checkin-btn-r-plus {
      border-radius: 26px;
      // border: 1px solid #FFFFFF;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      color: #ffffff;
      color: #854a0d;
      background: linear-gradient(90deg, #ffdfb3 0%, #eab04e 100%);
      position: relative;

      .plus {
        position: absolute;
        top: -10px;
        font-size: 10px;
        width: 54px;
        height: 16px;
        right: 0px;
        border-radius: 10px 10px 10px 0px;

        div {
          // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
          background: linear-gradient(0deg, #ffdfb3 0%, #eab04e 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 800;
          font-size: 10px;
          // font-style: italic;
        }
      }
    }

    .checkin-btn-r-ultra {
      // background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
      background: linear-gradient(0deg, #5a68ff 0%, #95a5ff 100%);
      border-radius: 26px;
      // border: 1px solid #FFFFFF;
      // height: ;
      padding: 10px 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      // color: #490D73;
      color: #ffffff;
      position: relative;

      .ultra {
        position: absolute;
        top: -10px;
        font-size: 10px;
        width: 54px;
        height: 16px;
        right: 0px;
        border-radius: 10px 10px 10px 0px;
        background: #27053e;

        .ultra-box {
          background: linear-gradient(0deg, #e9d6ff 0%, #a66cfe 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 800;
          font-size: 10px;
        }
      }
    }

    .checkin-btn-r-ultra-ed {
      background: linear-gradient(0deg, #5a68ff 0%, #95a5ff 100%);
      border-radius: 23px;
      opacity: 0.5;
      padding: 10px 0;

      font-weight: 800;
      font-size: 14px;
      // color: #490D73;
      color: #ffffff;
    }

    .checkin-btn-vip {
      border-radius: 26px;
      // border: 1px solid #FFFFFF;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      font-size: 14px;
      color: #0d1d73;
      background: linear-gradient(90deg, #d6dfff 0%, #6990ff 100%);
    }
  }
}

.checkin-btn-l {
  border-radius: 26px;
  border: 1px solid #ffffff;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  color: #ffffff;
}

.checkin-btn-r {
  flex: 1;
  // background: linear-gradient(270deg, #5A68FF 0%, #95A5FF 100%);
  // background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
  border: 1px solid #7284f7;
  border-radius: 26px;
  font-weight: 800;
  font-size: 14px;
  // color: #490D73;
  color: #7284f7;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .checkin-btn-r-text {
    position: absolute;
    top: -10px;
    right: 0;
    font-size: 12px;
    color: #ffffff;
    font-weight: 500;
    // background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
    background: #27053e;
    border-radius: 100px 100px 100px 0px;
    padding: 2px 10px;
    font-weight: 500;
    font-size: 10px;
    color: #854a0d;

    div {
      background: linear-gradient(0deg, #e9d6ff 0%, #a66cfe 100%);
      // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-weight: 800;
      // font-size: 12px;
      font-size: 10px;
      // font-style: italic;
    }
  }
}

// 任务区域
.tasks-section {
  padding: 24px 0px;

  .tasks-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 2px;

    .tasks-title {
      font-size: 14px;
      font-weight: 800;
      // color: #374151;
    }
  }

  .tasks-subtitle {
    margin-bottom: 10px;
  }

  .task-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .task-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: #1b1d32;
    border-radius: 10px;
    padding: 15px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    animation: taskItemSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;

    @keyframes taskItemSlideIn {
      0% {
        transform: translateX(-20px);
        opacity: 0;
      }

      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .task-icon {
      flex-shrink: 0;
      // background: #F3F4F6;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .task-content {
      display: flex;
      justify-content: center;
      align-items: center;

      .task-name {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
        max-width: 160px;
        // margin-bottom: 4px;
      }

      .task-desc {
        font-size: 12px;
        color: #9ca3af;
        margin-top: 2px;
      }
    }

    .task-actions {
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 13px;
      display: flex;
      // flex-direction: column;
      align-items: center;
      // gap: 8px;
      padding-right: 8px;
      justify-content: space-between;
      width: 100px;

      .task-reward {
        display: flex;
        align-items: center;
        gap: 0px;
        font-weight: 900;
        font-size: 12px;
        color: #fff;
        justify-content: center;
      }

      .task-btn {
        background: linear-gradient(0deg, #5a68ff 0%, #95a5ff 100%);
        padding: 0 10px;
        line-height: 25px;
        border-radius: 13px;
        text-align: center;
        font-weight: 900;
        font-size: 12px;
        // background: rgba(114, 132, 247, 0.2);
        border-radius: 13px;
        color: #fff;

        &.btn-go {
          // background: #E0E7FF;
          // color: #6366F1;

          &:hover {
            background: #c7d2fe;
          }
        }

        &.btn-receive {
          background: linear-gradient(180deg, #7b88ff 0%, #6366f1 100%);
          color: #ffffff;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(123, 136, 255, 0.3);
          }
        }
      }
    }
  }
}

.day-item-dot {
  animation: dotFadeIn 0.4s ease-out both;
  background: rgba(255, 255, 255, 0.2);
}

.day-label-text {
  animation: labelTextFadeIn 0.4s ease-out both;
}

.progress-fill-item {
  animation: progressFillSlide 0.6s ease-out both;
}

@keyframes dotFadeIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes labelTextFadeIn {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes progressFillSlide {
  0% {
    width: 0 !important;
    opacity: 0;
  }

  100% {
    width: 38px !important;
    opacity: 1;
  }
}

.checkin-text {
  color: v-bind('theme.colors.textPrimary');
}

.plus-icon {
  font-weight: 500;
  font-size: 8px;
  color: #eab04e;
  width: 40px;
  height: 16px;
  background: #01031b;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  .plus-icon-text {
    background: linear-gradient(0deg, #ffdfb3 0%, #eab04e 100%);
    // background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
    // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    // font-weight: 800;
    // font-size: 12px;
    font-size: 8px;
  }
}

.ultra-icon {
  font-weight: 500;
  font-size: 8px;
  color: #a66cfe;
  width: 40px;
  height: 16px;
  background: #01031b;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  .ultra-icon-box {
    // background: linear-gradient(0deg, #FFDFB3 0%, #EAB04E 100%);
    background: linear-gradient(0deg, #e9d6ff 0%, #a66cfe 100%);
    // background: linear-gradient(0deg, #E9D6FF 0%, #A66CFE 100%);
    // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    // font-weight: 800;
    // font-size: 12px;
    font-size: 8px;
  }
}

.box-bg {
  background: linear-gradient(180deg, #272f40 0%, #2c2e3f 100%);
  border-radius: 20px;
}

.task-btn-receive {
  padding: 0 8px;
  width: 100px;
  height: 25px;
  background: linear-gradient(180deg, #5a68ff 0%, #95a5ff 100%);
  border-radius: 13px;
  font-weight: 900;
  font-size: 12px;
  color: #ffffff;
  line-height: 25px;
  text-align: center;

  &.active {
    opacity: 0.5;
  }
}

.checkin-btn-r-ed {
  // background: linear-gradient(0deg, #5A68FF 0%, #95A5FF 100%);
  border-radius: 23px;
  opacity: 0.5;
  font-weight: 800;
  font-size: 16px;
  // color: #FFFFFF;
  color: #7284f7;
  border: 1px solid #7284f7;
}

.checkin-btn-l-upgrade {
  // line-height: ;
  height: 42px;
  line-height: 42px;
  flex: 1;
  border-radius: 23px;
  font-weight: 800;
  font-size: 16px;
  color: #ffffff;
  padding: 0 45px;
  background: linear-gradient(0deg, #5a68ff 0%, #95a5ff 100%);
  position: relative;
  .Ultra {
    width: 54px;
    height: 16px;
    background: linear-gradient(90deg, #e9d6ff 0%, #a66cfe 100%);
    border-radius: 20px 20px 20px 0px;
    text-align: center;
    line-height: 16px;
    font-weight: 800;
    font-size: 10px;
    color: #490d73;
  }
}
.check_in {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 10px 0;
}
</style>
